import React, { useState } from 'react';
import cn from 'classnames';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ReactComponent as Delete } from '@assets/images/delete.svg';
import { TouchableButton } from '@components/common/Touchable';
import { LABEL, CUSTOM_MESSAGES } from '@veriables';
import { deleteAllItems } from './CartActionHandler';
import { finaliseOrder } from './CartPaymentHandler';
import { changeCheckOrdersTab } from '@reducers/orders';
import style from './CartButtons.module.scss';
import { getObjectValue } from '@utility/utills';
import { safeJsonParse } from '@utility/helperFunction';
import getDeviceType from '@utility/deviceType';
import ActionConfirmationModal from '../Modals/ActionConfirmationModal/index';

const whiteFontStyle = {
  color: 'rgb(255, 255, 255)',
  fontSize: '13.5px',
  fontWeight: 500,
  whiteSpace: 'nowrap',
  lineHeight: 1,
  textAlign: 'center',
  overflow: 'visible',
};

const CounterModeActions = ({
  cart,
  serverAppTheme,
  changeCheckOrdersTab,
  isCheckBoxClicked,
  checkedItems,
  resetCheckBoxState,
}) => {
  const [deleteModal, setDeleteModal] = useState({ isOpen: false });
  const navigate = useNavigate();
  const selectedItems =
    cart?.reduce((sum, item) => sum + item.quantity, 0) ?? 0;
  const isCartEmpty = (cart?.length ?? 0) === 0;
  const { isCallCenter, isDriveThru } = getDeviceType();

  const checkedItemsQuantity = isCheckBoxClicked
    ? cart
        ?.filter(
          item => checkedItems?.[item.id] || checkedItems?.[item.internalId]
        )
        .reduce((sum, item) => sum + (item.quantity || 0), 0) ?? 0
    : null;

  const deleteCount =
    checkedItemsQuantity !== null ? checkedItemsQuantity : selectedItems;

  const handleDelete = () => {
    setDeleteModal({ isOpen: false });
    deleteAllItems(isCheckBoxClicked ? checkedItems : null);
    changeCheckOrdersTab({ isPendingList: false });
    resetCheckBoxState?.(false);
  };

  const handleFinalise = () => {
  const getStoredVal = key => Number(sessionStorage.getItem(key)) || null;

   const driveThruSelections = isDriveThru
  ? {
      lane: getStoredVal('driveThru_selectedLane'),
      vehicleType: getStoredVal('driveThru_selectedVehicleType'),
      vehicleColor: getStoredVal('driveThru_selectedVehicleColor'),
    }
  : {};

    finaliseOrder({
      isDriveThru: isDriveThru,
      isCounter: !isDriveThru,
      isTogo: false,
      isCallCenter: isCallCenter,
      driveThruSelections,
      navigate,
    });
    window.sessionStorage.removeItem('menuScrollTop');
  };

  return (
    <div className="col-12 px-0 d-flex flex-column" style={{ gap: '4px' ,position:'absolute' , bottom:'0px' }}>
      <div className="col-12 px-0">
        <TouchableButton
          type="button"
          onClick={e => {
            e.preventDefault();
            setDeleteModal({ isOpen: true });
          }}
          disabled={isCartEmpty}
          className={cn(style.bottomBtn, 'px-0')}
          style={{
            backgroundColor: isCartEmpty
              ? 'rgb(177, 177, 177)'
              : 'rgb(116, 164, 255)',
            width: '100%',
            height: '40px',
            borderRadius: '4px',
            padding: '2.5px 5px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '4px',
            ...whiteFontStyle,
            color:
              selectedItems > 0
                ? serverAppTheme?.btn_font_color
                : serverAppTheme?.btn_font_color_disabled,
          }}
          rippleEffect={true}
        >
          {isCheckBoxClicked ? (
            `${LABEL().DELETE} (${deleteCount})`
          ) : (
            <div className='fs_16 fw-400'>
              <Delete
                fill={
                  isCartEmpty
                    ? serverAppTheme?.btn_font_color_disabled
                    : serverAppTheme?.btn_font_color
                }
                width={18}
                height={18}
                className={cn('position-relative mr-1')}
                style={{top: "-1px"}}
              />
              {!isNaN(deleteCount) ? `(${deleteCount})` : ''}
            </div>
          )}
        </TouchableButton>
      </div>

      <div className="col-12 px-0">
        <TouchableButton
          type="button"
          onClick={e => {
            e.preventDefault();
            handleFinalise();
          }}
          disabled={isCartEmpty}
          className={cn(style.bottomBtn, 'px-0')}
          style={{
            background: isCartEmpty
              ? '#345388'
              : serverAppTheme?.enabledPayBtn,
            width: '100%',
            height: '40px',
            color: isCartEmpty ? "#A0A0A0" : 'rgb(255, 255, 255)',
            fontSize: '20px',
            fontWeight: '500',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '4px',
            opacity: isCartEmpty ? "0.65": "1"
          }}
          rippleEffect={true}
        >
          {LABEL().FINALIZE_ORDER}
        </TouchableButton>
      </div>
      {deleteModal?.isOpen && (
        <ActionConfirmationModal
          isOpen={deleteModal?.isOpen}
          onClose={() => setDeleteModal({ isOpen: false })}
          data={null}
          customMessage={
            isCheckBoxClicked
              ? CUSTOM_MESSAGES().SINGLE_SELECTED_DELETE_MSG
              : CUSTOM_MESSAGES().DELETE_MULTIPLE_MSG
          }
          handleSubmit={handleDelete}
        />
      )}
    </div>
  );
};

const mapStateToProps = ({ orders, theme }) => ({
  cart: orders.cart,
  serverAppTheme: theme.serverAppTheme,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ changeCheckOrdersTab }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CounterModeActions);
